import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const START_SECONDS = 17 * 60 + 34;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function CountdownTimer() {
  const [remaining, setRemaining] = useState(START_SECONDS);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? START_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const blocks = [{
    value: pad(hours),
    label: 'ore'
  }, {
    value: pad(minutes),
    label: 'min'
  }, {
    value: pad(seconds),
    label: 'sec'
  }];
  return <div className="flex flex-col items-center gap-2.5" data-id="element-20" data-mp="34qi6ovkcuh1i">
      <p className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-alert" data-id="element-21" data-mp="34pyzo9w8td29">
        <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-22" data-mp="2zpkoiizchn00" />
        L’offerta di oggi scade tra
      </p>
      <div className="flex items-center gap-2" role="timer" aria-live="off" aria-label={`Tempo rimanente ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`} data-id="element-23" data-mp="1c31erfa0mydt">
        {blocks.map((block, index) => <React.Fragment key={block.label} data-id="element-24" data-mp="170sk8ehhvo9l" data-mpi={index}>
            <div className="flex w-[62px] flex-col items-center rounded-xl bg-navy-deep px-2 py-2 sm:w-[74px]" data-id="element-25" data-mp="173ohe0liq8wz">
              <span className="font-display text-2xl font-bold tabular-nums text-white sm:text-3xl" data-id="element-26" data-mp="1utiumj9r1zhr">
                {block.value}
              </span>
              <span className="text-[9px] font-bold uppercase tracking-[0.16em] text-white/55" data-id="element-27" data-mp="1l0btjam1l5nh">
                {block.label}
              </span>
            </div>
            {index < blocks.length - 1 ? <span className="font-display text-xl text-navy/40" aria-hidden="true" data-id="element-28" data-mp="2dp8ykc18t5ya">
                :
              </span> : null}
          </React.Fragment>)}
      </div>
    </div>;
}